import React, { useMemo, useEffect } from 'react';
import { PipesAndSpanColumns, PipesAndSpanTableType } from '@/types';
import { GenericIdmsTable } from './GenericIdmsTable';
type Props = {
  pipesAndSpanData: PipesAndSpanTableType;
  loading?: boolean;
  metaData?: Record<string, unknown> | undefined;
  setAssociatedPipingCount?: React.Dispatch<React.SetStateAction<number>>;
};

export const PipesAndSpanTables = ({
  pipesAndSpanData,
  loading,
  metaData,
  setAssociatedPipingCount,
}: Props) => {
  const tableRows: Array<Record<string, unknown>> = useMemo(
    () =>
      Array.isArray(pipesAndSpanData?.rows) ? (pipesAndSpanData.rows as PipesAndSpanColumns[]) : [],
    [pipesAndSpanData]
  );

  const columns = useMemo(() => {
    const headers = Array.isArray(metaData?.headers ?? pipesAndSpanData?.headers)
      ? ((metaData?.headers ?? pipesAndSpanData?.headers) as PipesAndSpanColumns[])
      : [];
    return headers;
  }, [metaData?.headers, pipesAndSpanData?.headers]);

  useEffect(() => {
    setAssociatedPipingCount?.(tableRows.length);
  }, [tableRows, setAssociatedPipingCount]);

  return (
    <GenericIdmsTable loading={loading} tableRows={tableRows} columns={columns}></GenericIdmsTable>
  );
};
